import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_3d7df4e1 from 'nuxt_plugin_plugin_3d7df4e1' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_vuescrollto_6d409bda from 'nuxt_plugin_vuescrollto_6d409bda' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_2eedf612 from 'nuxt_plugin_cookieuniversalnuxt_2eedf612' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_3223b2cc from 'nuxt_plugin_pluginutils_3223b2cc' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_6aec2dc0 from 'nuxt_plugin_pluginseo_6aec2dc0' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_23fa85d2 from 'nuxt_plugin_pluginrouting_23fa85d2' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_42421db8 from 'nuxt_plugin_pluginmain_42421db8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin4ff195f6_35aaf812 from 'nuxt_plugin_distplugin4ff195f6_35aaf812' // Source: ./dist.plugin.4ff195f6.mjs (mode: 'all')
import nuxt_plugin_image_e75e3f6c from 'nuxt_plugin_image_e75e3f6c' // Source: ./image.js (mode: 'all')
import nuxt_plugin_corepluginf1f02cbc_ae4ddea8 from 'nuxt_plugin_corepluginf1f02cbc_ae4ddea8' // Source: ./core.plugin.f1f02cbc.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting16e7bc02_20fbebae from 'nuxt_plugin_pluginse2etesting16e7bc02_20fbebae' // Source: ./plugins.e2e-testing.16e7bc02.js (mode: 'all')
import nuxt_plugin_deviceplugin_6726884c from 'nuxt_plugin_deviceplugin_6726884c' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_0fa27eaa from 'nuxt_plugin_workbox_0fa27eaa' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_087e2cbe from 'nuxt_plugin_metaplugin_087e2cbe' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_0d25d232 from 'nuxt_plugin_iconplugin_0d25d232' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_customcontext_454b7849 from 'nuxt_plugin_customcontext_454b7849' // Source: ../plugins/custom-context (mode: 'all')
import nuxt_plugin_votpinput_26a354db from 'nuxt_plugin_votpinput_26a354db' // Source: ../plugins/v-otp-input (mode: 'all')
import nuxt_plugin_scrollposition_b29b541a from 'nuxt_plugin_scrollposition_b29b541a' // Source: ../plugins/scroll-position (mode: 'all')
import nuxt_plugin_directives_521c021a from 'nuxt_plugin_directives_521c021a' // Source: ../plugins/directives.ts (mode: 'all')
import nuxt_plugin_oncustomerchat_574a72f6 from 'nuxt_plugin_oncustomerchat_574a72f6' // Source: ../plugins/oncustomer-chat.js (mode: 'all')
import nuxt_plugin_clevertapclient_5672e8e4 from 'nuxt_plugin_clevertapclient_5672e8e4' // Source: ../plugins/clevertap.client.js (mode: 'client')
import nuxt_plugin_initdatastore_5452c032 from 'nuxt_plugin_initdatastore_5452c032' // Source: ../plugins/init-data-store.js (mode: 'all')
import nuxt_plugin_meta_266f9433 from 'nuxt_plugin_meta_266f9433' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"vi"},"meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1,user-scalable=no"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fdynamic.criteo.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fscript.crazyegg.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fconnect.facebook.net","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","crossorigin":true}],"script":[{"innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-TMV33V');","type":"text\u002Fjavascript","charset":"utf-8"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3d7df4e1 === 'function') {
    await nuxt_plugin_plugin_3d7df4e1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_6d409bda === 'function') {
    await nuxt_plugin_vuescrollto_6d409bda(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2eedf612 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2eedf612(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3223b2cc === 'function') {
    await nuxt_plugin_pluginutils_3223b2cc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_6aec2dc0 === 'function') {
    await nuxt_plugin_pluginseo_6aec2dc0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_23fa85d2 === 'function') {
    await nuxt_plugin_pluginrouting_23fa85d2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_42421db8 === 'function') {
    await nuxt_plugin_pluginmain_42421db8(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin4ff195f6_35aaf812 === 'function') {
    await nuxt_plugin_distplugin4ff195f6_35aaf812(app.context, inject)
  }

  if (typeof nuxt_plugin_image_e75e3f6c === 'function') {
    await nuxt_plugin_image_e75e3f6c(app.context, inject)
  }

  if (typeof nuxt_plugin_corepluginf1f02cbc_ae4ddea8 === 'function') {
    await nuxt_plugin_corepluginf1f02cbc_ae4ddea8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting16e7bc02_20fbebae === 'function') {
    await nuxt_plugin_pluginse2etesting16e7bc02_20fbebae(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_6726884c === 'function') {
    await nuxt_plugin_deviceplugin_6726884c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_0fa27eaa === 'function') {
    await nuxt_plugin_workbox_0fa27eaa(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_087e2cbe === 'function') {
    await nuxt_plugin_metaplugin_087e2cbe(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_0d25d232 === 'function') {
    await nuxt_plugin_iconplugin_0d25d232(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_customcontext_454b7849 === 'function') {
    await nuxt_plugin_customcontext_454b7849(app.context, inject)
  }

  if (typeof nuxt_plugin_votpinput_26a354db === 'function') {
    await nuxt_plugin_votpinput_26a354db(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollposition_b29b541a === 'function') {
    await nuxt_plugin_scrollposition_b29b541a(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_521c021a === 'function') {
    await nuxt_plugin_directives_521c021a(app.context, inject)
  }

  if (typeof nuxt_plugin_oncustomerchat_574a72f6 === 'function') {
    await nuxt_plugin_oncustomerchat_574a72f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clevertapclient_5672e8e4 === 'function') {
    await nuxt_plugin_clevertapclient_5672e8e4(app.context, inject)
  }

  if (typeof nuxt_plugin_initdatastore_5452c032 === 'function') {
    await nuxt_plugin_initdatastore_5452c032(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_266f9433 === 'function') {
    await nuxt_plugin_meta_266f9433(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
